// Documentación viva de la estrategia de cada bot (estado a 24 Jun 2026).
// Fuente de los parámetros:
//  - Hyperliquid: hyperliquid_bot/src/strategies/profit_swarm/config.py + profit_swarm_config.json
//  - Sniper:      ftmo_bot/mql5/EA_XAUUSD_Sniper_Invictus.mq5
//  - Sentimental: ftmo_bot/mql5/EA_BTC_Sentiment_Invictus.mq5 + sentiment_engine/sentiment/signal_engine.py
//  - FTMO LBFP:   ftmo_bot/src/strategies/london_breakout_fp.py
export const LAST_UPDATED = '2 de julio de 2026';

export const STRATEGIES = [
  {
    id: 'hyperliquid',
    name: 'Hyperliquid Profit Swarm',
    strategyId: 'profit_swarm_donchian_atr_volume_v1',
    accent: '#22d3ee',
    status: 'EN REAL',
    venue: 'Hyperliquid DEX',
    market: 'BTC · ETH · SOL · DOGE · XRP',
    timeframe: '4H',
    tagline: 'Ruptura de tendencia en 4H. Sin objetivo fijo: deja correr el beneficio con un stop dinámico que se arrastra detrás del precio.',
    idea:
      'Es una estrategia de ruptura de tendencia en velas de 4 horas. La filosofía es entrar cuando el precio rompe con fuerza y quedarse montado todo el tiempo que dure el movimiento, cortando las pérdidas rápido y dejando correr las ganancias. No usa un objetivo de beneficio fijo (Take Profit): la salida la gobierna un stop que se va moviendo a tu favor en cada cierre de vela.',
    entryTitle: 'Cómo entra (deben cumplirse las 4 a la vez, en la vela 4H que cierra)',
    entry: [
      { t: 'Ruptura Donchian', d: 'El precio cierra por encima del máximo (largo) o por debajo del mínimo (corto) de las últimas 36–48 velas. Marca el inicio de un movimiento fuerte.' },
      { t: 'Filtro de tendencia (EMA 200)', d: 'Solo va largo si el precio está por encima de la media de 200, y corto si está por debajo. Nunca rema contra la corriente principal.' },
      { t: 'Expansión de ATR (volatilidad)', d: 'El ATR debe estar por encima de su media: confirma que el mercado se mueve de verdad y no está dormido.' },
      { t: 'Expansión de volumen', d: 'El volumen de la vela supera su media reciente (×1.3–1.5): hay dinero real detrás de la ruptura, no un amago falso.' },
    ],
    hasTP: false,
    exitTitle: 'Cómo sale (no hay Take Profit fijo — trailing stop dinámico)',
    exit: [
      { t: 'Stop inicial (ATR)', d: 'Al entrar coloca un único SL a una distancia de ATR × atr_sl_mult del precio. Es la única protección al principio.' },
      { t: 'Trailing por ATR', d: 'En cada cierre de vela 4H, recalcula el stop a ATR × atr_trail_mult del extremo reciente. Si el precio va a tu favor, el stop lo sigue (en un corto baja, en un largo sube). El stop SOLO se mueve para protegerte más, nunca hacia atrás.' },
      { t: 'Break-even a 1.5R', d: 'Cuando la operación gana 1.5 veces lo arriesgado, mueve el stop al precio de entrada: a partir de ahí, en el peor caso, sales sin pérdida.' },
      { t: 'Cierre', d: 'La operación se cierra cuando el precio se da la vuelta y toca el stop arrastrado. Hyperliquid ejecuta el SL de forma nativa.' },
    ],
    paramGroups: [
      {
        group: 'Gestión y riesgo',
        rows: [
          { k: 'Riesgo por operación', v: '1.0% del equity', n: 'Tamaño calculado por la distancia al stop (ATR)' },
          { k: 'Apalancamiento', v: '3× (aislado)', n: 'Margen isolated por posición' },
          { k: 'Posiciones simultáneas', v: 'Máx. 5', n: 'Una por símbolo' },
          { k: 'Operaciones por día', v: 'Máx. 6', n: 'Tope de sobre-operativa' },
          { k: 'Corte por drawdown', v: '15%', n: 'Pausa entradas si la cuenta cae 15% desde su pico' },
          { k: 'Dirección', v: 'Largos y cortos', n: 'long_short' },
          { k: 'Break-even', v: 'Activo a 1.5R', n: 'Mueve el stop a la entrada' },
        ],
      },
    ],
    presets: {
      title: 'Parámetros por símbolo (presets)',
      columns: ['Símbolo', 'Donchian', 'EMA', 'ATR', 'SL ×ATR', 'Trail ×ATR', 'Vol ×'],
      rows: [
        ['BTC', '48', '200', '14', '2.0', '3.0', '1.5'],
        ['ETH', '48', '200', '14', '2.2', '3.2', '1.4'],
        ['SOL', '36', '200', '14', '2.3', '3.0', '1.4'],
        ['DOGE', '36', '200', '14', '2.5', '3.5', '1.3'],
        ['XRP', '36', '200', '14', '2.4', '3.2', '1.4'],
      ],
    },
    riskNotes: [
      'El bot solo evalúa y mueve los stops UNA vez por vela (cierres 4H: 00:00, 04:00, 08:00, 12:00, 16:00, 20:00 UTC). Entre medias está en silencio.',
      'Con 5 símbolos puede tener hasta 5 posiciones a la vez; en cripto suelen estar correlacionadas (≈5% de riesgo de cuenta si todas tocaran SL juntas).',
    ],
  },

  {
    id: 'sniper',
    name: 'Sniper — Gold Momentum Selective (v2)',
    strategyId: 'EA_XAUUSD_Sniper_Invictus · sniper_v2.0',
    accent: '#fbbf24',
    status: 'EN REAL',
    venue: 'MetaTrader 5',
    market: 'XAUUSD (Oro)',
    timeframe: 'M5 (contexto H1)',
    tagline: 'Momentum SELECTIVO sobre el Oro en M5: menos operaciones, pero de mayor calidad. Solo entra si tendencia, fuerza, volatilidad, una vela de impulso real y el coste (spread+comisión) acompañan.',
    idea:
      'Versión 2 (revamp completo del "Micro Sniper" v1). Sube de M1 a M5 con contexto en H1 y se vuelve mucho más exigente para evitar la sobre-operativa y el ruido. La filosofía: esperar a que TODO se alinee (tendencia + momentum + volatilidad + vela de impulso) y que el objetivo cubra de sobra el coste de operar, entrar con riesgo bajo y dejar correr con trailing por ATR. Si la operación no progresa en pocos minutos, la corta (scratch) para no inmovilizar riesgo.',
    entryTitle: 'Cómo entra (deben cumplirse todas, al cierre de vela M5)',
    entry: [
      { t: 'Tendencia alineada (EMA 21/50 + H1)', d: 'EMA 21 y 50 en M5 alineadas y la EMA 50 en H1 confirmando la dirección. Nunca opera contra el contexto de H1.' },
      { t: 'Fuerza (ADX ≥ 26)', d: 'Umbral más alto que en v1 (era 20): exige momentum real y descarta mercados dubitativos.' },
      { t: 'Ruptura de estructura (20 velas)', d: 'El precio rompe el máximo/mínimo de las últimas 20 velas M5 (v1 usaba 8).' },
      { t: 'Vela de impulso real', d: 'El cuerpo de la vela ≥ 50% del ATR y la mecha ≤ el cuerpo: confirma empuje genuino, no un amago.' },
      { t: 'Volatilidad mínima (ATR ≥ 120 pts)', d: 'Garantiza que el objetivo es mayor que el coste; evita el mercado plano.' },
      { t: 'Filtro de coste (TP ≥ 3× coste)', d: 'Si el objetivo no cubre al menos 3 veces (spread + comisión estimada), NO opera. Clave para ser rentable neto.' },
      { t: 'Ventanas horarias', d: 'Solo 07:00–11:00 y 13:00–17:00 (servidor); los viernes corta a las 15:00. Una operación por vela.' },
    ],
    hasTP: true,
    exitTitle: 'Cómo sale',
    exit: [
      { t: 'Stop técnico (ATR × 1.3)', d: 'SL a ATR(14) × 1.3 del precio de entrada: se adapta a la volatilidad real.' },
      { t: 'Take Profit (RR 2.0)', d: 'Objetivo ≥ 2 veces el riesgo (v1 buscaba objetivos cortos de scalping; v2 deja correr más).' },
      { t: 'Break-even a +1R', d: 'Al ganar 1× el riesgo, mueve el stop a la entrada +5 puntos: operación protegida temprano.' },
      { t: 'Trailing por ATR (desde +1R)', d: 'A partir de +1R arrastra el stop a ATR × 1.5, dejando correr la tendencia. Solo se mueve a tu favor.' },
      { t: 'Scratch por no-progreso', d: 'Si en 25 minutos no avanza al menos +0.5R, cierra la operación (libera riesgo en movimientos que no arrancan).' },
      { t: 'Salida por reversión de estructura', d: 'Si la estructura del precio se da la vuelta en contra, sale aunque no haya tocado SL/TP.' },
    ],
    paramGroups: [
      {
        group: 'Gestión y riesgo',
        rows: [
          { k: 'Lotaje', v: 'Fijo 0.01 (margin-safe)', n: 'Riesgo % de referencia: 0.25% · margen libre mín. 200%' },
          { k: 'Stop / Take Profit', v: 'ATR×1.3 / RR 2.0', n: 'Objetivo ≥ 2R' },
          { k: 'Break-even', v: 'a +1R (+5 pts)', n: 'Protección temprana' },
          { k: 'Trailing', v: 'ATR×1.5 desde +1R', n: 'Deja correr la tendencia' },
          { k: 'Scratch no-progreso', v: '25 min / +0.5R', n: 'Corta lo que no arranca' },
          { k: 'Operaciones por día', v: 'Máx. 3', n: 'Anti sobre-operativa' },
          { k: 'Pérdidas seguidas', v: 'Máx. 2', n: 'Pausa tras 2 stops seguidos' },
          { k: 'Límite pérdida diaria', v: '1.0% equity', n: 'Corte duro del día' },
          { k: 'Spread máx. entrada', v: '35 puntos', n: 'Filtro anti-slippage' },
          { k: 'Magic number', v: '20260617', n: 'Sin cambios respecto a v1' },
        ],
      },
    ],
    riskNotes: [
      'v2 es SELECTIVA: hace bastantes menos operaciones que v1, buscando calidad. Es normal ver días sin entradas.',
      'No opera si el Take Profit no cubre al menos 3× el coste (spread + comisión): protege la rentabilidad neta.',
      'El scratch por no-progreso puede cerrar operaciones en pequeño (+/-) para no inmovilizar riesgo en movimientos que no despegan.',
    ],
  },

  {
    id: 'sentimental',
    name: 'Sentimental — BTC Sentiment (Contrarian)',
    strategyId: 'EA_BTC_Sentiment_Invictus v1.10 + Sentiment Engine',
    accent: '#a78bfa',
    status: 'EN REAL',
    venue: 'MetaTrader 5 + API',
    market: 'BTCUSD',
    timeframe: 'M15',
    tagline: 'Trading CONTRARIAN dirigido por un motor de sentimiento: mide el exceso de la masa (funding, posicionamiento, liquidaciones…) y opera CONTRA la multitud sobreapalancada.',
    idea:
      'Este bot no decide la dirección por análisis técnico clásico: un motor propio (API) lee cómo está posicionada la masa en el mercado de BTC y opera a la CONTRA de los excesos. Vende cuando la multitud está demasiado larga y apalancada (funding alto, ratio largos/cortos elevado, sobrecompra) y compra cuando está demasiado corta o hay capitulación (funding negativo, sobreventa, cascada de liquidaciones de largos = posible rebote). El motor combina 6 métricas en un score de −100 a +100 y el EA lo ejecuta con gestión por ATR y múltiplos de riesgo (R).',
    entryTitle: 'Cómo entra',
    entry: [
      { t: 'Señal del motor (cada 30s)', d: 'Consulta la API de sentimiento. Abre solo si |score| supera el umbral y la confianza es ≥ 50.' },
      { t: 'Filtro de score mínimo', d: 'Exige |score| ≥ 35 (fuerza mínima del sesgo) para evitar señales débiles.' },
      { t: 'Dirección', d: 'Largos y cortos, según el sesgo contrarian de la señal.' },
      { t: 'Filtro de spread y horario', d: 'No entra si el spread supera 2500 puntos. Opera 07:00–22:00, sin fines de semana.' },
    ],
    hasTP: true,
    exitTitle: 'Cómo sale',
    exit: [
      { t: 'Take Profit (RR 1.5)', d: 'Objetivo = 1.5 veces el riesgo asumido.' },
      { t: 'Stop por ATR', d: 'SL = ATR(14) en M15 × 1.5: se adapta a la volatilidad del momento.' },
      { t: 'Break-even a +1R', d: 'Al ganar 1× el riesgo, mueve el stop a la entrada (+0.05R).' },
      { t: 'Trailing en R', d: 'Arranca a 1.2R y arrastra a 0.6R de distancia.' },
      { t: 'Señal contraria', d: 'Cierra la operación si el motor emite una señal opuesta.' },
      { t: 'Cooldown tras pérdida', d: 'Tras un stop, espera 120 min antes de volver a operar (evita revenge-trading).' },
    ],
    paramGroups: [
      {
        group: 'Gestión y riesgo (EA v1.10)',
        rows: [
          { k: 'Lotaje', v: 'Fijo 0.01', n: 'Riesgo % ref: 0.10% · riesgo $ máx: 5' },
          { k: 'Confianza mínima', v: '50 / 100', n: 'Umbral de la señal' },
          { k: 'Score mínimo', v: '|35|', n: 'Fuerza mínima del sesgo' },
          { k: 'Refresco API', v: '30 s', n: 'Frecuencia de consulta' },
          { k: 'Stop / RR', v: 'ATR(14)×1.5 / 1:1.5', n: 'Dinámico por volatilidad' },
          { k: 'Break-even / Trailing', v: '+1R / 1.2R→0.6R', n: 'Protección + arrastre' },
          { k: 'Operaciones por día', v: 'Máx. 1', n: 'Selectivo' },
          { k: 'Pérdidas seguidas', v: 'Máx. 2 · cooldown 120 min', n: 'Anti revenge-trading' },
          { k: 'Límite pérdida diaria', v: '1.0% equity', n: 'Corte duro del día' },
          { k: 'Horario', v: '07:00–22:00 · sin findes', n: 'Ventana operativa' },
          { k: 'Magic number', v: '20260618', n: 'Identificador en MT5' },
        ],
      },
      {
        group: 'Motor de sentimiento — pesos de los factores (contrarian)',
        rows: [
          { k: 'Funding', v: '25%', n: 'Funding alto+ (largos pagan) → sesgo corto' },
          { k: 'Ratio Largos/Cortos', v: '20%', n: 'Exceso de largos → corto (a la contra)' },
          { k: 'OI vs precio', v: '20%', n: 'OI↑ con precio↑ = largos tardíos; OI↑ con precio↓ = posible short squeeze' },
          { k: 'RSI (+ extremos 24h)', v: '15%', n: 'Sobrecompra→corto / sobreventa→largo, reforzado por rechazo en máx/mín' },
          { k: 'Liquidaciones', v: '10%', n: 'Cascada de largos liquidados → posible rebote (long)' },
          { k: 'Flujo taker', v: '10%', n: 'Desbalance de flujo agresivo (peso bajo, pro-momentum)' },
          { k: 'Umbral de señal', v: '|score| ≥ 20', n: 'Por debajo = NO_TRADE · TTL señal 30 min' },
        ],
      },
    ],
    riskNotes: [
      'Mejoras del motor (jun 2026): la CONFIANZA ya no es solo |score|, se pondera por la CONFLUENCIA entre factores independientes (acuerdo). Señales con factores contradictorios pesan menos.',
      'Suavizado EMA del score entre ciclos: mata el "parpadeo" de la señal y evita entradas/salidas por ruido.',
      'Calidad de datos: si faltan fuentes clave, dampea la confianza y por debajo del 50% de fuentes vivas fuerza NO_TRADE (no opera con datos incompletos).',
      'Validación honesta: una señal solo cuenta como acierto/fallo si el precio se movió ≥ 0.1%; por debajo se marca "flat" (ruido).',
      'Detección de régimen (tendencia/lateral) con aprendizaje de pesos por régimen para futura calibración.',
      'Depende de la disponibilidad del motor (API). Si la API cae, no genera señales nuevas. Muy selectivo: máx. 1 operación al día.',
    ],
  },

  {
    id: 'ftmo',
    name: 'FTMO — London Breakout (LBFP)',
    strategyId: 'london_breakout_fp · preset atr_c3b',
    accent: '#34d399',
    status: 'EN REAL',
    venue: 'MetaTrader 5 (FTMO)',
    market: 'XAUUSD (Oro)',
    timeframe: 'H1 (armado OCO intradía)',
    tagline: 'Ruptura de la sesión de Londres con órdenes pendientes OCO: arma a las 07:00, dispara con el breakout del rango asiático y caduca a las 12:00.',
    idea:
      'Aprovecha la explosión de volatilidad de la apertura de Londres. Mide el rango de la sesión asiática (00:00–06:59 UTC) y, a las 07:00, coloca dos órdenes pendientes: una compra por encima del máximo asiático y una venta por debajo del mínimo. La primera que se dispara cancela a la otra (OCO). Las que no se activan caducan a las 12:00. Diseñada con reglas estrictas para superar el FTMO Challenge.',
    entryTitle: 'Cómo entra',
    entry: [
      { t: 'Rango asiático', d: 'Calcula máximo y mínimo de 00:00 a 06:59 UTC: son los niveles de ruptura.' },
      { t: 'Armado OCO a las 07:00', d: 'Coloca BUY_STOP en el máximo asiático y SELL_STOP en el mínimo. Al dispararse una, se cancela la otra.' },
      { t: 'Caducidad 12:00 UTC', d: 'Si ninguna se dispara dentro de la ventana de Londres, las pendientes se cancelan limpiamente.' },
      { t: 'Filtro de spread', d: 'No entra si el spread instantáneo supera 8 pips al disparar.' },
    ],
    hasTP: true,
    exitTitle: 'Cómo sale',
    exit: [
      { t: 'Stop por ATR (preset atr_c3b)', d: 'SL = máx(8 pips, ATR(14) × 1.0). Se adapta al ruido real de Londres en el Oro.' },
      { t: 'Take Profit (RR 2.5)', d: 'Objetivo = 2.5 veces el riesgo (validado en backtest con PF 1.83).' },
      { t: 'Stop-on-Win', d: 'Si ya ganó una operación, no abre más ese día: protege el resultado.' },
      { t: 'Trailing multifase', d: 'Asegura beneficio por tramos según el % de equity ganado (1.9% / 2.2%).' },
    ],
    paramGroups: [
      {
        group: 'Gestión y riesgo',
        rows: [
          { k: 'Riesgo por operación', v: '0.5% del equity', n: 'Lotaje por riesgo (pip-based)' },
          { k: 'Stop / Take Profit', v: 'ATR(14)×1.0 / RR 2.5', n: 'Preset atr_c3b (mejor en backtest)' },
          { k: 'Operaciones por día', v: 'Máx. 2', n: 'Con Stop-on-Win' },
          { k: 'Ventana', v: 'Arma 07:00 · caduca 12:00 UTC', n: 'Sesión de Londres' },
          { k: 'Buffer de spread', v: '5 pips (sizing)', n: 'Comisión $4/lote ida-vuelta' },
          { k: 'Spread máx. entrada', v: '8 pips', n: 'Filtro anti-slippage' },
          { k: 'Magic number', v: '20260521', n: 'Identificador en MT5' },
        ],
      },
    ],
    riskNotes: [
      'Solo opera en la ventana de Londres (07:00–12:00 UTC). En días de rango lateral puede no entrar — es normal.',
      'Pensado para reglas FTMO: prioriza preservar capital (riesgo bajo, Stop-on-Win, máx. 2 trades/día).',
    ],
  },
];
